import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RequestStrategyEnum, TransactionsApi, type TransactionRequest, type TransactionResponse, type WithSignal } from '@shared/api';

const getTransactionsEffect = createEffect(({ signal, ...request }: WithSignal<TransactionRequest> = {}) =>
  TransactionsApi.getTransactions(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: TransactionResponse[] }>({ data: [], total: 0 })
  .on(getTransactionsEffect.done, (_, data) => (data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] }))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getTransactionsEffect.pending, (_, data) => data)
  .on(getTransactionsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getTransactionsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getTransactionsEffect, () => null)
  // .on(getTransactionsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getTransactionsEffect.fail, () => 'Something went wrong while fetching Transactions. Please try again.')
  .on(getTransactionsEffect.done, () => null)
  .reset(clearEvent);

const getTransactionsApi = ApiUtils.wrapperApi(getTransactionsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getTransactionsApi.cancel());

export const $transactionStore = {
  events: {
    getTransactions: getTransactionsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
